/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { WorkerSources } from './worker-sources';


export interface SearchWorkersDictionaryRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    source?: WorkerSources;
    sources?: Array<WorkerSources> | null;
    facilityIds?: Array<string> | null;
    containerIds?: Array<string> | null;
}



